<template>
  <div class="navigation">
    <Form @submitSuccess="getList" ref="form" :activeName="activeName"/>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="顶部导航" name="header" height="100%"></el-tab-pane>
      <el-tab-pane label="中部导航" name="middle" height="100%"></el-tab-pane>
      <el-tab-pane label="底部导航" name="footer" height="100%"></el-tab-pane>
    </el-tabs>
        <div class="groupButton" style="padding-top: 0.1vw">
          <AppButton customType="default" @click="addMenu">新增导航</AppButton>
        </div>
        <BasicTable
          hiddenFooter
          :tableData="tableData"
          :treeProps="{ children: 'child', hasChildren: 'hasChildren' }"
          :columns="columns"
          height="auto">
          <template v-slot:add_time="{ item }">
            {{item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
          </template>
          <template v-slot:is_show="{ item }">
            <CheckBox v-model="item.is_show" @change="showNavigation(item)" ></CheckBox>
          </template>
          <template v-slot:operate="{ item }">
            <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
            <AppButton type="primary" plain size="small" @click="deleteMenu(item)" v-if="item.child.length===0"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
          </template>
          <template v-slot:nav_type="{ item }">
            <el-tag
              :type="item.nav_type === 'header' ? '' : item.nav_type === 'middle' ? 'success' : 'info'"
              effect="dark">
              {{ item.nav_type === 'header' ? '顶部导航' : item.nav_type === 'middle' ? '中部导航' : '底部导航'}}
            </el-tag>
          </template>
        </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { Navigate } from '../../assets/utils/navigate'
import { WebsiteService } from '../../service/website.service';
import Form from './formNavigation';
const columns = [
  { name: '名称', key: 'name' },
  { name: '是否显示', key: 'is_show', type: 'custom'},
  { name: '创建时间', key: 'add_time', type: 'custom'},
  { name: '导航类型', key: 'nav_type', type: 'custom' },
  { name: '操作', key: 'operate', type: 'custom' }
];
const nav_type = [{value: 'header',label: '顶部导航'},{value: 'middle', label: '中部导航'},{value: 'footer', label: '底部导航'}]
  export default {
    name: 'navigation',
    components: { Form },
    data() {
      return {
        tableData: [],
        columns,
        nav_type,
        data:{},//所有数据
        activeName: 'header',
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await WebsiteService.getNavigationList();
        this.data = JSON.parse(JSON.stringify(data))
        switch(this.activeName) {
          case 'header':
            this.tableData = data.header
            break
          case 'middle':
            this.tableData = data.middle
            break
          case 'footer':
            this.tableData = data.footer
            break
        }
        this.data_type = data.data_type
      },
      addMenu() {
        this.$refs.form.open('add',this.data,this.activeName,this.nav_type);
      },
      editMenu(item_data) {
        this.$refs.form.open('edit',this.data,this.activeName,this.nav_type,item_data);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条导航吗？', '删除导航').then(async () => {
          await WebsiteService.delNavigation(data.id);
          this.getList();
        })
      },
      showNavigation(item) {
          WebsiteService.switchNavigationStatus(item.id,item.is_show ? 1 : 0)

      },
      async handleClick() {
        switch(this.activeName) {
          case 'header':
            this.tableData = this.data.header
            break
          case 'middle':
            this.tableData = this.data.middle
            break
          case 'footer':
            this.tableData = this.data.footer
            break
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>

<style lang="scss" scoped>
  .navigation{
    .el-tabs{
        .el-tabs__header{
          margin: 0;
          padding-bottom: 1vw;
          color: #666
        }
        .el-tabs__nav-wrap::after{
          background: #3a3b44;
        }
        
        background: #fff;
        padding: 0 1vw;
        padding-top: 1vw;
        .el-tabs__item{
            color: #666;
            padding-left: 1vw!important;
            padding-right: 1vw!important;
        }
        .el-tabs__item:hover{
          color: #3a3b44;
        }
        .el-tabs__item.is-active{
          color: #a7b1c2;
          background: #3a3b44;
        }
        .el-tabs__item.is-active:hover{
          color: #eee;
        }
        .el-tabs__active-bar{
          background: transparent;
        }
    }
  }
</style>